<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de validade de material">
            <rkm-layout-content>
                <List :dispensacao="dispensacao"/>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/almoxarifado/relatorio-validade-material/List'

export default {
    components: { List },
    props: {
        dispensacao: { type: Boolean, default: false }
    },
}
</script>